import { render, staticRenderFns } from "./SipremHome.vue?vue&type=template&id=11c14526&"
import script from "./SipremHome.vue?vue&type=script&lang=js&"
export * from "./SipremHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports